import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";

import SideBar from "../Components/SideBar";
import TextEditor from "../Components/textEditor";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";
import { GetBlogApi, PostBlogApi, PutBlogApi } from "../callApi/blog";
import { toast, Toaster } from "react-hot-toast";
import MediaPicker from "../Components/mediaPicker";
import { fileUpload } from "../../fileUpload";

import config from "../Config.json";
export default function AddBlogPost() {
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;
  const [buttonText, setButtonText] = useState("Save to draft");

  const [data, setData] = useState({
    feature_image: { image: "", file: "", status: "none" },
    title: "",
    description: "",
    permalink: "",
    content: "",
    author: "",
  });

  const _data = data;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { _id } = useParams();

  useEffect(() => {
    // dispatch(setLoading(true))
    if (_id) {
      GetBlogApi("blogs/edit/" + _id)
        .then((res) => {
          setData({
            // ...res,
            content: res[0].content || "",
            title: res[0].title || "",
            description: res[0].description || "",
            permalink: res[0].permalink || "",
            author: res[0].author || "",
            status: res[0].status || "",
            feature_image: {
              status: "none",
              image: config.awsMediaPath + res[0].feature_image,
              imageName: res[0].feature_image,
            },
          });
          sessionStorage.setItem("blogApi", JSON.stringify(res));
          if (res[0].status === "published") {
            setButtonText("Revert to Draft");
          }
        })
        .catch((error) => {
          toast.error("Error fetching data. Please try again!");
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
      // updateData();
    }
  }, []);

  //save data
  const saveData = (imageUrl, status) => {
    const params = {
      content: data.content,
      title: data.title,
      description: data.description,
      author: data.author,
      feature_image: imageUrl,
      permalink: data.permalink,
      status,
      AdminId: AdminId,
    };
    if (!_id) {
      PostBlogApi(params)
        .then((res) => {
          dispatch(setLoading(false));
          if (res) {
            navigate("/admin/blog")
            toast.success("Data saved successfully");
          } else {
            toast.error("Something went wrong");
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          toast.error("Error saving data! Please try again");
        });
    } else {
      PutBlogApi(params, "blogs/edit/" + _id)
        .then((res) => {
          dispatch(setLoading(false));
          if (res) {
            navigate("/admin/blog")
            toast.success("data saved successfully");
          } else {
            toast.error("something went wrong");
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          toast.error("Error saving data! please try again");
        });
    }
  };

  const updateData = () => {
    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  //handle save when user clicks on save button
  const handleSave = async (status) => {
    dispatch(setLoading(true));
    if (
      data.title != "" &&
      data.content != "" &&
      data.description != "" &&
      data.author != "" &&
      data.feature_image != ""
    ) {
      if (data.feature_image.status === "updated") {
        fileUpload([data.feature_image]).then((uploadImgRes) => {
          if (uploadImgRes?.length > 0) {
            const newUploadImage = uploadImgRes[0].key;
            saveData(newUploadImage, status);
          }
        });
      } else {
        saveData(data.feature_image.imageName, status);
      }
    } else {
      dispatch(setLoading(false));
      toast.error("Please fill all the valus");
    }
  };
  return (
    <div className="add-blog-post">
      <SideBar />
      <div className="admin-container">
        {!_id ? <h2>Add Blog Post</h2> : <h2>Edit Blog Post</h2>}
        <div className="sec">
          <div className="top">
            <div className="blog-buttons">
              <button className="btn-draft" onClick={() => handleSave("draft")}>
                {buttonText}
              </button>
              <button
                className="btn-published"
                onClick={() => handleSave("published")}
              >
                Publish
              </button>
              <Link to="/admin/blog">
                <button className="btn-cancel">Cancel</button>
              </Link>
            </div>
          </div>
          <div className="sec blog-data">
            <TextEditor
              onChange={(text) => {
                _data.content = text;
                updateData();
              }}
              value={_data.content}
            />
            <div className="add-blog-right">
              <div className="sec add-title">
                {/* title */}
                <div className="title">
                  <label>Title</label>
                  <br />
                  <input
                    type="text"
                    className="add-blog-title"
                    onChange={(event) => {
                      const { value } = event.currentTarget;
                      setData((prevData) => ({
                        ...prevData,
                        title: value,
                      }));
                    }}
                    value={_data.title}
                  ></input>
                </div>
              </div>
              {/* Description */}
              <div className="sec add-title">
                <div className="description">
                  <label>Description</label>
                  <br />
                  <input
                    type="text"
                    className="add-blog-description"
                    onChange={(text) => {
                      text = text.currentTarget.value;
                      _data.description = text;
                      updateData();
                    }}
                    value={_data.description}
                  ></input>
                </div>
              </div>
              {/* blog link */}
              <div className="sec add-title">
                <div className="blog-link">
                  <label>permalink</label>
                  <br />
                  <input
                    type="text"
                    className="add-blog-link"
                    onChange={(text) => {
                      text = text.currentTarget.value;
                      _data.permalink = text;
                      updateData();
                    }}
                    value={_data.permalink}
                  ></input>
                </div>
              </div>
              {/* author */}
              <div className="sec add-title">
                <div className="author">
                  <label>Author</label>
                  <br />
                  <input
                    type="text"
                    className="add-author"
                    onChange={(text) => {
                      text = text.currentTarget.value;
                      _data.author = text;
                      updateData();
                    }}
                    value={_data.author}
                  ></input>
                </div>
              </div>
              {/* blog image */}

              {_id ? (
                <MediaPicker
                  type="image"
                  onChange={(file, image) => {
                    _data.feature_image = { file, image, status: "updated" };
                    updateData();
                  }}
                  source={data.feature_image.image}
                  text="Blog image"
                />
              ) : (
                <MediaPicker
                  type="image"
                  onChange={(file, image) => {
                    _data.feature_image.file = file;
                    _data.feature_image.image = image;
                    _data.feature_image.status = "updated";

                    updateData();
                  }}
                  source={data.feature_image.image}
                  text="Blog image"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
